import { useState, useEffect } from 'react';

/**
 * Custom hook to manage tab data fetching on demand.
 * - Fetches when the tab component mounts (tab switch)
 * - No background polling
 * - Manual refetch is available for retry/refresh actions
 */
export const useTabData = (tabName, fetchFunction) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch data function
  const performFetch = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const result = await fetchFunction();
      setData(result);
    } catch (err) {
      setError(err.message || 'Failed to fetch data');
      console.error(`Error in ${tabName}:`, err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch when the tab component mounts (or fetch function changes)
  useEffect(() => {
    performFetch();
  }, [tabName, fetchFunction]);

  const refetch = () => {
    performFetch();
  };

  return { data, isLoading, error, refetch };
};
